// extracted by mini-css-extract-plugin
export default {"recos":"R6-z","productCardOverride":"S6-z","rowHasBadge":"T6-z"};